export default __webpack_public_path__ + "static/media/innovation.8c1065aa.svg";